import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
  initAttributeInfo,
  requestAttributeStart,
  requestAttributeSuccess,
  requestAttributeFail,
} from '../actions/attribute';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET } = requestManagement;

import CONFIG from '@root/config/config.next';
const url = CONFIG.backendEndpoint;

export function* requestAttribute(data) {

  /*console.log('[sages] requestAttribute : ', data);*/

  const apiURL = `${url}/api/v1/attribute`;

  //====================================================================================================================

  try {
    const data = yield method_GET({ url: apiURL });

    /*console.log("[API] GET : ",);*/

    yield put(requestAttributeSuccess(data));

  } catch (error) {
    yield put(requestAttributeFail(error));
  }

  //====================================================================================================================

}

export function* watchAttribute() {

  /*console.log('[sages] watchAttribute : ✅');*/

  yield all([
    takeLatest(requestAttributeStart, requestAttribute),
  ])
}



